import React, { useState } from 'react';
import { Segmented, Typography } from 'antd';
import type { FiltersCriteria } from '../../../services/bulk-email.service';
import { UserFilterFields } from './UserFilterFields';
import { SurveyPicker } from './SurveyPicker';
import { JsonRecipientUpload } from './JsonRecipientUpload';

const { Text } = Typography;

export type RecipientSourceState =
  | { source: 'FILTERS'; criteria: FiltersCriteria; recipientCount: number | null; variables: string[] }
  | { source: 'SURVEY'; surveyId: number | null; recipientCount: number | null; variables: string[] }
  | { source: 'JSON'; file: File | null; recipientCount: number | null; variables: string[] }
  | null;

export type RecipientOrigin = 'FILTERS' | 'SURVEY' | 'JSON';

interface RecipientSourceFormProps {
  onChange: (state: RecipientSourceState) => void;
}

/**
 * Seleção de origem de destinatários (FR-002). Cada origem é implementada e
 * plugada aqui em sua respectiva user story (US1: FILTERS, US2: SURVEY,
 * US3: JSON) — ver tasks.md T033/T041/T049.
 */
export const RecipientSourceForm: React.FC<RecipientSourceFormProps> = ({ onChange }) => {
  const [origin, setOrigin] = useState<RecipientOrigin | null>(null);

  const handleOriginChange = (value: RecipientOrigin) => {
    setOrigin(value);
    onChange(null);
  };

  return (
    <div>
      <Segmented
        options={[
          { label: 'Filtros de cadastro', value: 'FILTERS' },
          { label: 'Participantes de pesquisa', value: 'SURVEY' },
          { label: 'Upload de lista (JSON)', value: 'JSON' },
        ]}
        value={origin ?? undefined}
        onChange={(value) => handleOriginChange(value as RecipientOrigin)}
      />
      <div style={{ marginTop: 16 }}>
        {origin === 'FILTERS' && (
          <UserFilterFields
            onChange={(criteria, recipientCount) =>
              onChange({ source: 'FILTERS', criteria, recipientCount, variables: [] })
            }
          />
        )}
        {origin === 'SURVEY' && (
          <SurveyPicker
            onChange={(surveyId, recipientCount) =>
              onChange(
                surveyId
                  ? { source: 'SURVEY', surveyId, recipientCount, variables: ['nomePreferido'] }
                  : null
              )
            }
          />
        )}
        {origin === 'JSON' && (
          <JsonRecipientUpload
            onChange={(file, recipientCount, variables) =>
              onChange(file ? { source: 'JSON', file, recipientCount, variables } : null)
            }
          />
        )}
        {!origin && <Text type="secondary">Selecione uma origem de destinatários para continuar.</Text>}
      </div>
    </div>
  );
};
